// Selling plan management for quick-view 
(() => {
  const processedClicks = new WeakSet();

  const handleQuickViewClick = (button) => {
    if (processedClicks.has(button)) return;
    processedClicks.add(button);
    
    setTimeout(() => {
      if (window.Abra && typeof window.Abra.render === 'function') {
        window.Abra.render();
        window.Abra.useSellingPlanPriceOnProductBlock = true;
        window.Abra.render();
      }
      processedClicks.delete(button);
    }, 1500);
  };

  const checkInitialSelection = () => {
    if (window.location.pathname.includes('/products') && window.Abra && typeof window.Abra.render === 'function') {
      const selectedRadio = document.querySelector('input[type="radio"][data-subscription-type]:checked');
      if (selectedRadio) {
        if (selectedRadio.dataset.subscriptionType === 'subscription') {
          window.Abra.useSellingPlanPriceOnProductBlock = true;
          window.Abra.render();
        } else if (selectedRadio.dataset.subscriptionType === 'one-time') {
          window.Abra.useSellingPlanPriceOnProductBlock = false;
          window.Abra.render();
        }
      }
    }
  };

  document.addEventListener('click', (e) => {
    const button = e.target.closest('quick-view-button');
    if (button) {
      handleQuickViewClick(button);
    }

    const radioInput = e.target.closest('input[type="radio"][data-subscription-type]');
    if (radioInput && window.Abra && typeof window.Abra.render === 'function') {
      if (radioInput.dataset.subscriptionType === 'subscription') {
        window.Abra.useSellingPlanPriceOnProductBlock = true;
        window.Abra.render();
      } else if (radioInput.dataset.subscriptionType === 'one-time') {
        window.Abra.useSellingPlanPriceOnProductBlock = false;
        window.Abra.render();
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkInitialSelection);
  } else {
    checkInitialSelection();
  }
})();
